import {
    SiNetflix, SiAmazonprime, SiHbo, SiAppletv, SiYoutube, SiCrunchyroll, SiFunimation,
    SiSpotify, SiApplemusic, SiAmazonmusic, SiTidal, SiPandora, SiSoundcloud, SiPlaystation, SiNintendoswitch, SiEa, SiGoogleplay, SiApple, SiHumblebundle,
    SiNvidia, SiUbisoft, SiGooglecloud, SiDropbox, SiOnedrive,
    SiIcloud, SiBox, SiMega, SiGoogle, SiEvernote, SiNotion,
    SiTodoist, SiTrello, SiAsana, SiSlack, SiAirtable, SiClickup, SiMondaydotcom,
    SiZoom, SiCalendly, SiAmazon, SiWalmart, SiInstacart,
    SiPeloton, SiFitbit, SiStrava, SiHeadspace,
    SiUdemy, SiCoursera, SiSkillshare, SiKhanacademy, SiDuolingo, SiRosettastone,
    SiLinkedin, SiBrilliant, SiCodecademy, SiPluralsight,
    SiAdobecreativecloud, SiCanva, SiFigma, SiSketch, SiQuickbooks,
    SiShopify, SiWix, SiSquarespace, SiWordpress, SiHootsuite, SiBuffer,
    SiNordvpn, SiExpress, SiSurfshark, SiMcafee, SiNorton,
    SiLastpass, SiDashlane,
    SiPatreon, SiOnlyfans, SiAudible, SiTinder, SiNow, SiDazn,
    // Add any other icons you need
} from 'react-icons/si'

export const subscriptionConfigs = [
    // Streaming Services - Video
    {
        id: 'netflix',
        name: 'Netflix',
        icon: SiNetflix,
        category: 'streaming',
        defaultPrice: 15.99,
        currency: 'USD',
        description: 'Streaming service for movies and TV shows',
        defaultPlan: 'monthly',
        plans: { monthly: 15.99, yearly: 191.88 },
        popularity: 95
    },
    {
        id: 'amazon-prime-video',
        name: 'Amazon Prime Video',
        icon: SiAmazonprime,
        category: 'streaming',
        defaultPrice: 8.99,
        currency: 'USD',
        description: 'Amazon streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 8.99, yearly: 89.00 },
        popularity: 90
    },
    {
        id: 'disney-plus',
        name: 'Disney+',
        // icon: SiDisneyplus,
        category: 'streaming',
        defaultPrice: 7.99,
        currency: 'USD',
        description: 'Disney streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 7.99, yearly: 79.99 },
        popularity: 88
    },
    {
        id: 'hulu',
        name: 'Hulu',
        // icon: SiHulu,
        category: 'streaming',
        defaultPrice: 7.99,
        currency: 'USD',
        description: 'Hulu streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 7.99, yearly: 79.99 },
        popularity: 85
    },
    {
        id: 'hbo-max',
        name: 'HBO Max',
        icon: SiHbo,
        category: 'streaming',
        defaultPrice: 15.99,
        currency: 'USD',
        description: 'HBO Max streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 15.99, yearly: 149.99 },
        popularity: 83
    },
    {
        id: 'apple-tv-plus',
        name: 'Apple TV+',
        icon: SiAppletv,
        category: 'streaming',
        defaultPrice: 6.99,
        currency: 'USD',
        description: 'Apple TV+ streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 6.99, yearly: 69.99 },
        popularity: 80
    },
    {
        id: 'youtube-premium',
        name: 'YouTube Premium',
        icon: SiYoutube,
        category: 'streaming',
        defaultPrice: 11.99,
        currency: 'USD',
        description: 'Ad-free YouTube experience with Premium features',
        defaultPlan: 'monthly',
        plans: { monthly: 11.99, yearly: 119.99 },
        popularity: 82
    },
    {
        id: 'peacock',
        name: 'Peacock',
        // icon: SiPeacock,
        category: 'streaming',
        defaultPrice: 5.99,
        currency: 'USD',
        description: 'NBCUniversal streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 5.99, yearly: 59.99 },
        popularity: 75
    },
    {
        id: 'paramount-plus',
        name: 'Paramount+',
        // icon: SiParamount,
        category: 'streaming',
        defaultPrice: 5.99,
        currency: 'USD',
        description: 'Paramount streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 5.99, yearly: 59.99 },
        popularity: 73
    },
    {
        id: 'discovery-plus',
        name: 'Discovery+',
        // icon: SiDiscoveryplus,
        category: 'streaming',
        defaultPrice: 4.99,
        currency: 'USD',
        description: 'Discovery streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 4.99, yearly: 49.99 },
        popularity: 70
    },
    {
        id: 'crunchyroll',
        name: 'Crunchyroll',
        icon: SiCrunchyroll,
        category: 'streaming',
        defaultPrice: 7.99,
        currency: 'USD',
        description: 'Anime streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 7.99, yearly: 79.99 },
        popularity: 65
    },

    // Music Streaming Services
    {
        id: 'spotify',
        name: 'Spotify',
        icon: SiSpotify,
        category: 'music',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'Music streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 99.99 },
        popularity: 92
    },
    {
        id: 'apple-music',
        name: 'Apple Music',
        icon: SiApplemusic,
        category: 'music',
        defaultPrice: 1001.99,
        currency: 'USD',
        description: 'Apple music streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 10.99, yearly: 109.00 },
        popularity: 85
    },
    {
        id: 'amazon-music',
        name: 'Amazon Music',
        icon: SiAmazonmusic,
        category: 'music',
        defaultPrice: 8.99,
        currency: 'USD',
        description: 'Amazon music streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 8.99, yearly: 89.00 },
        popularity: 80
    },
    {
        id: 'tidal',
        name: 'Tidal',
        icon: SiTidal,
        category: 'music',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'High-fidelity music streaming',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 99.99 },
        popularity: 65
    },
    {
        id: 'deezer',
        name: 'Deezer',
        // icon: SiDeezer,
        category: 'music',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'Music streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 99.99 },
        popularity: 60
    },

    // Gaming Services
    {
        id: 'xbox-gamepass',
        name: 'Xbox Game Pass',
        // icon: SiXbox,
        category: 'gaming',
        defaultPrice: 14.99,
        currency: 'USD',
        description: 'Xbox gaming subscription service',
        defaultPlan: 'monthly',
        plans: { monthly: 14.99, yearly: 179.88 },
        popularity: 85
    },
    {
        id: 'playstation-plus',
        name: 'PlayStation Plus',
        icon: SiPlaystation,
        category: 'gaming',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'PlayStation gaming subscription',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 59.99 },
        popularity: 83
    },
    {
        id: 'nintendo-switch-online',
        name: 'Nintendo Switch Online',
        icon: SiNintendoswitch,
        category: 'gaming',
        defaultPrice: 3.99,
        currency: 'USD',
        description: 'Nintendo online gaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 3.99, yearly: 19.99 },
        popularity: 80
    },
    {
        id: 'ea-play',
        name: 'EA Play',
        icon: SiEa,
        category: 'gaming',
        defaultPrice: 4.99,
        currency: 'USD',
        description: 'EA gaming subscription service',
        defaultPlan: 'monthly',
        plans: { monthly: 4.99, yearly: 29.99 },
        popularity: 75
    },

    // Cloud Storage & Productivity
    {
        id: 'google-one',
        name: 'Google One',
        icon: SiGoogle,
        category: 'cloud',
        defaultPrice: 1.99,
        currency: 'USD',
        description: 'Google cloud storage service',
        defaultPlan: 'monthly',
        plans: { monthly: 1.99, yearly: 19.99 },
        popularity: 85
    },
    {
        id: 'dropbox',
        name: 'Dropbox',
        icon: SiDropbox,
        category: 'cloud',
        defaultPrice: 11.99,
        currency: 'USD',
        description: 'Cloud storage and file sharing',
        defaultPlan: 'monthly',
        plans: { monthly: 11.99, yearly: 119.88 },
        popularity: 80
    },
    {
        id: 'microsoft-365',
        name: 'Microsoft 365',
        // icon: SiMicrosoftoffice,
        category: 'productivity',
        defaultPrice: 6.99,
        currency: 'USD',
        description: 'Microsoft Office suite and cloud storage',
        defaultPlan: 'monthly',
        plans: { monthly: 6.99, yearly: 69.99 },
        popularity: 88
    },
    // ... continuing with more services

    // Productivity Tools
    {
        id: 'notion',
        name: 'Notion',
        icon: SiNotion,
        category: 'productivity',
        defaultPrice: 8.00,
        currency: 'USD',
        description: 'All-in-one workspace for notes and collaboration',
        defaultPlan: 'monthly',
        plans: { monthly: 8.00, yearly: 96.00 },
        popularity: 78
    },
    {
        id: 'evernote',
        name: 'Evernote',
        icon: SiEvernote,
        category: 'productivity',
        defaultPrice: 14.99,
        currency: 'USD',
        description: 'Note-taking and organization',
        defaultPlan: 'monthly',
        plans: { monthly: 14.99, yearly: 169.99 },
        popularity: 70
    },
    {
        id: 'todoist',
        name: 'Todoist',
        icon: SiTodoist,
        category: 'productivity',
        defaultPrice: 4.00,
        currency: 'USD',
        description: 'Task management and organization',
        defaultPlan: 'monthly',
        plans: { monthly: 4.00, yearly: 48.00 },
        popularity: 72
    },
    {
        id: 'trello',
        name: 'Trello',
        icon: SiTrello,
        category: 'productivity',
        defaultPrice: 10.00,
        currency: 'USD',
        description: 'Project management and collaboration',
        defaultPlan: 'monthly',
        plans: { monthly: 10.00, yearly: 100.00 },
        popularity: 75
    },
    {
        id: 'asana',
        name: 'Asana',
        icon: SiAsana,
        category: 'productivity',
        defaultPrice: 10.99,
        currency: 'USD',
        description: 'Project management platform',
        defaultPlan: 'monthly',
        plans: { monthly: 10.99, yearly: 131.88 },
        popularity: 73
    },
    {
        id: 'slack',
        name: 'Slack',
        icon: SiSlack,
        category: 'productivity',
        defaultPrice: 7.25,
        currency: 'USD',
        description: 'Business communication platform',
        defaultPlan: 'monthly',
        plans: { monthly: 7.25, yearly: 87.00 },
        popularity: 85
    },

    // Fitness & Health
    {
        id: 'peloton',
        name: 'Peloton',
        icon: SiPeloton,
        category: 'fitness',
        defaultPrice: 12.99,
        currency: 'USD',
        description: 'Digital fitness classes and workouts',
        defaultPlan: 'monthly',
        plans: { monthly: 12.99, yearly: 129.99 },
        popularity: 75
    },
    {
        id: 'fitbit-premium',
        name: 'Fitbit Premium',
        icon: SiFitbit,
        category: 'fitness',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'Advanced health and fitness insights',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 79.99 },
        popularity: 70
    },
    {
        id: 'strava',
        name: 'Strava',
        icon: SiStrava,
        category: 'fitness',
        defaultPrice: 7.99,
        currency: 'USD',
        description: 'Activity tracking for athletes',
        defaultPlan: 'monthly',
        plans: { monthly: 7.99, yearly: 59.99 },
        popularity: 68
    },
    {
        id: 'calm',
        name: 'Calm',
        // icon: SiCalm,
        category: 'wellness',
        defaultPrice: 14.99,
        currency: 'USD',
        description: 'Meditation and mindfulness app',
        defaultPlan: 'monthly',
        plans: { monthly: 14.99, yearly: 69.99 },
        popularity: 72
    },
    {
        id: 'headspace',
        name: 'Headspace',
        icon: SiHeadspace,
        category: 'wellness',
        defaultPrice: 12.99,
        currency: 'USD',
        description: 'Meditation and mental wellness app',
        defaultPlan: 'monthly',
        plans: { monthly: 12.99, yearly: 69.99 },
        popularity: 70
    },

    // Education & Learning
    {
        id: 'udemy',
        name: 'Udemy',
        icon: SiUdemy,
        category: 'education',
        defaultPrice: 29.99,
        currency: 'USD',
        description: 'Online learning platform',
        defaultPlan: 'monthly',
        plans: { monthly: 29.99, yearly: 359.88 },
        popularity: 80
    },
    {
        id: 'coursera',
        name: 'Coursera',
        icon: SiCoursera,
        category: 'education',
        defaultPrice: 49.00,
        currency: 'USD',
        description: 'Online courses from universities',
        defaultPlan: 'monthly',
        plans: { monthly: 49.00, yearly: 499.00 },
        popularity: 78
    },
    {
        id: 'skillshare',
        name: 'Skillshare',
        icon: SiSkillshare,
        category: 'education',
        defaultPrice: 15.00,
        currency: 'USD',
        description: 'Creative skills learning platform',
        defaultPlan: 'monthly',
        plans: { monthly: 15.00, yearly: 99.00 },
        popularity: 75
    },
    {
        id: 'duolingo-plus',
        name: 'Duolingo Plus',
        icon: SiDuolingo,
        category: 'education',
        defaultPrice: 6.99,
        currency: 'USD',
        description: 'Language learning platform',
        defaultPlan: 'monthly',
        plans: { monthly: 6.99, yearly: 83.88 },
        popularity: 77
    },
    {
        id: 'linkedin-learning',
        name: 'LinkedIn Learning',
        icon: SiLinkedin,
        category: 'education',
        defaultPrice: 29.99,
        currency: 'USD',
        description: 'Professional development courses',
        defaultPlan: 'monthly',
        plans: { monthly: 29.99, yearly: 299.88 },
        popularity: 73
    },

    // Security Services
    {
        id: 'nordvpn',
        name: 'NordVPN',
        icon: SiNordvpn,
        category: 'security',
        defaultPrice: 11.99,
        currency: 'USD',
        description: 'Virtual Private Network service',
        defaultPlan: 'monthly',
        plans: { monthly: 11.99, yearly: 59.88 },
        popularity: 75
    },
    {
        id: 'lastpass',
        name: 'LastPass',
        icon: SiLastpass,
        category: 'security',
        defaultPrice: 3.00,
        currency: 'USD',
        description: 'Password management service',
        defaultPlan: 'monthly',
        plans: { monthly: 3.00, yearly: 36.00 },
        popularity: 70
    },
    {
        id: '1password',
        name: '1Password',
        // icon: Si1password,
        category: 'security',
        defaultPrice: 2.99,
        currency: 'USD',
        description: 'Password manager and secure vault',
        defaultPlan: 'monthly',
        plans: { monthly: 2.99, yearly: 35.88 },
        popularity: 72
    },

    // Creative & Business Tools
    {
        id: 'adobe-creative-cloud',
        name: 'Adobe Creative Cloud',
        icon: SiAdobecreativecloud,
        category: 'creative',
        defaultPrice: 52.99,
        currency: 'USD',
        description: 'Suite of creative software applications',
        defaultPlan: 'monthly',
        plans: { monthly: 52.99, yearly: 599.88 },
        popularity: 85
    },
    {
        id: 'canva-pro',
        name: 'Canva Pro',
        icon: SiCanva,
        category: 'creative',
        defaultPrice: 12.99,
        currency: 'USD',
        description: 'Online graphic design platform',
        defaultPlan: 'monthly',
        plans: { monthly: 12.99, yearly: 119.99 },
        popularity: 82
    },
    {
        id: 'figma',
        name: 'Figma',
        icon: SiFigma,
        category: 'creative',
        defaultPrice: 15.00,
        currency: 'USD',
        description: 'Collaborative interface design tool',
        defaultPlan: 'monthly',
        plans: { monthly: 15.00, yearly: 144.00 },
        popularity: 80
    },
    {
        id: 'quickbooks',
        name: 'QuickBooks',
        icon: SiQuickbooks,
        category: 'business',
        defaultPrice: 25.00,
        currency: 'USD',
        description: 'Accounting software for businesses',
        defaultPlan: 'monthly',
        plans: { monthly: 25.00, yearly: 300.00 },
        popularity: 78
    },

    // Shopping & E-commerce
    {
        id: 'amazon-prime',
        name: 'Amazon Prime',
        icon: SiAmazon,
        category: 'shopping',
        defaultPrice: 14.99,
        currency: 'USD',
        description: 'Shopping and entertainment subscription',
        defaultPlan: 'monthly',
        plans: { monthly: 14.99, yearly: 139.00 },
        popularity: 93
    },
    {
        id: 'walmart-plus',
        name: 'Walmart+',
        icon: SiWalmart,
        category: 'shopping',
        defaultPrice: 12.95,
        currency: 'USD',
        description: 'Shopping and delivery subscription',
        defaultPlan: 'monthly',
        plans: { monthly: 12.95, yearly: 98.00 },
        popularity: 75
    },
    {
        id: 'instacart-express',
        name: 'Instacart Express',
        icon: SiInstacart,
        category: 'shopping',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'Grocery delivery service',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 99.00 },
        popularity: 70
    },
    {
        id: 'costco-membership',
        name: 'Costco Membership',
        // icon: SiCostco,
        category: 'shopping',
        defaultPrice: 5.00,
        currency: 'USD',
        description: 'Wholesale club membership',
        defaultPlan: 'yearly',
        plans: { yearly: 60.00 },
        popularity: 78
    },

    // Dating Apps
    {
        id: 'tinder-plus',
        name: 'Tinder Plus',
        icon: SiTinder,
        category: 'dating',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'Dating app premium features',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 99.99 },
        popularity: 85
    },
    {
        id: 'bumble-premium',
        name: 'Bumble Premium',
        // icon: SiBumble,
        category: 'dating',
        defaultPrice: 14.99,
        currency: 'USD',
        description: 'Dating app premium features',
        defaultPlan: 'monthly',
        plans: { monthly: 14.99, yearly: 149.99 },
        popularity: 80
    },

    // Content & Entertainment
    {
        id: 'kindle-unlimited',
        name: 'Kindle Unlimited',
        // icon: SiKindle,
        category: 'entertainment',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'E-book and audiobook subscription',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 119.88 },
        popularity: 75
    },
    {
        id: 'audible',
        name: 'Audible',
        icon: SiAudible,
        category: 'entertainment',
        defaultPrice: 14.95,
        currency: 'USD',
        description: 'Audiobook subscription service',
        defaultPlan: 'monthly',
        plans: { monthly: 14.95, yearly: 149.50 },
        popularity: 78
    },
    {
        id: 'patreon',
        name: 'Patreon',
        icon: SiPatreon,
        category: 'entertainment',
        defaultPrice: 5.00,
        currency: 'USD',
        description: 'Creator subscription platform',
        defaultPlan: 'monthly',
        plans: { monthly: 5.00 },
        popularity: 73
    },
    {
        id: 'onlyfans',
        name: 'OnlyFans',
        icon: SiOnlyfans,
        category: 'entertainment',
        defaultPrice: 9.99,
        currency: 'USD',
        description: 'Content creator subscription platform',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99 },
        popularity: 75
    },

    // Website & Marketing Tools
    {
        id: 'shopify',
        name: 'Shopify',
        icon: SiShopify,
        category: 'business',
        defaultPrice: 29.00,
        currency: 'USD',
        description: 'E-commerce platform',
        defaultPlan: 'monthly',
        plans: { monthly: 29.00, yearly: 348.00 },
        popularity: 83
    },
    {
        id: 'wix',
        name: 'Wix',
        icon: SiWix,
        category: 'business',
        defaultPrice: 16.00,
        currency: 'USD',
        description: 'Website builder platform',
        defaultPlan: 'monthly',
        plans: { monthly: 16.00, yearly: 192.00 },
        popularity: 75
    },
    {
        id: 'squarespace',
        name: 'Squarespace',
        icon: SiSquarespace,
        category: 'business',
        defaultPrice: 16.00,
        currency: 'USD',
        description: 'Website builder and hosting platform',
        defaultPlan: 'monthly',
        plans: { monthly: 16.00, yearly: 192.00 },
        popularity: 73
    },
    {
        id: 'wordpress-premium',
        name: 'WordPress Premium',
        icon: SiWordpress,
        category: 'business',
        defaultPrice: 8.00,
        currency: 'USD',
        description: 'Website and blog platform',
        defaultPlan: 'monthly',
        plans: { monthly: 8.00, yearly: 96.00 },
        popularity: 77
    },

    // Regional Services - India
    {
        id: 'jiosaavn',
        name: 'JioSaavn',
        // icon: SiJiosaavn,
        category: 'music',
        defaultPrice: 99,
        currency: 'INR',
        description: 'Indian music streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 99, yearly: 999 },
        popularity: 40
    },
    {
        id: 'hotstar',
        name: 'Disney+ Hotstar',
        // icon: SiHotstar,
        category: 'streaming',
        defaultPrice: 299,
        currency: 'INR',
        description: 'Indian streaming platform',
        defaultPlan: 'monthly',
        plans: { monthly: 299, yearly: 1499 },
        popularity: 45
    },
    {
        id: 'zee5',
        name: 'Zee5',
        // icon: SiZee5,
        category: 'streaming',
        defaultPrice: 199,
        currency: 'INR',
        description: 'Indian entertainment platform',
        defaultPlan: 'monthly',
        plans: { monthly: 199, yearly: 999 },
        popularity: 35
    },

    // Regional Services - UK
    {
        id: 'now-tv',
        name: 'NOW TV',
        icon: SiNow,
        category: 'streaming',
        defaultPrice: 9.99,
        currency: 'GBP',
        description: 'UK streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 9.99, yearly: 99.99 },
        popularity: 45
    },
    {
        id: 'britbox',
        name: 'BritBox',
        // icon: SiBritbox,
        category: 'streaming',
        defaultPrice: 5.99,
        currency: 'GBP',
        description: 'British streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 5.99, yearly: 59.99 },
        popularity: 40
    },

    // Regional Services - Australia
    {
        id: 'stan',
        name: 'Stan',
        // icon: SiStan,
        category: 'streaming',
        defaultPrice: 10.00,
        currency: 'AUD',
        description: 'Australian streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 10.00, yearly: 100.00 },
        popularity: 35
    },
    {
        id: 'kayo',
        name: 'Kayo Sports',
        // icon: SiKayo,
        category: 'sports',
        defaultPrice: 25.00,
        currency: 'AUD',
        description: 'Australian sports streaming',
        defaultPlan: 'monthly',
        plans: { monthly: 25.00, yearly: 250.00 },
        popularity: 30
    },

    // Regional Services - Europe
    {
        id: 'dazn',
        name: 'DAZN',
        icon: SiDazn,
        category: 'sports',
        defaultPrice: 19.99,
        currency: 'EUR',
        description: 'Sports streaming service',
        defaultPlan: 'monthly',
        plans: { monthly: 19.99, yearly: 199.99 },
        popularity: 50
    },
    {
        id: 'eurosport',
        name: 'Eurosport',
        // icon: SiEurosport,
        category: 'sports',
        defaultPrice: 6.99,
        currency: 'EUR',
        description: 'European sports network',
        defaultPlan: 'monthly',
        plans: { monthly: 6.99, yearly: 69.99 },
        popularity: 45
    },
];

// Update subscription categories
export const SUBSCRIPTION_CATEGORIES = [
    'streaming',
    'music',
    'gaming',
    'productivity',
    'cloud',
    'business',
    'creative',
    'education',
    'fitness',
    'wellness',
    'security',
    'shopping',
    'dating',
    'entertainment',
    'sports',
    'news',
    'other'
]; 